import React from "react";
import { useSettings } from "../../lib/useSettings";

export default function GooglePreview({ title, description, slug, path = "" }) {
  const { settings: s } = useSettings();
  // Utilise le domaine courant (preview/prod) ou un placeholder
  const domain = (typeof window !== "undefined" && window.location?.hostname) || "votre-domaine.fr";
  const url = `https://${domain}${path ? "/" + path : ""}${slug ? "/" + slug : ""}`;
  const score = computeScore(title, description);
  return (
    <div className="space-y-2">
      <div className="text-xs uppercase font-bold tracking-wider text-[color:var(--brand-sky)]">Aperçu Google</div>
      <div className="p-4 rounded-xl border bg-white">
        <div className="text-[13px] text-[#202124] truncate">{url}</div>
        <div className="text-[18px] text-[#1a0dab] leading-tight hover:underline cursor-pointer line-clamp-1 mt-0.5">{title || "(titre)"}</div>
        <div className="text-[13px] text-[#4d5156] leading-snug mt-1 line-clamp-2">{description || "(meta description)"}</div>
      </div>
      <div className="flex items-center gap-3 text-xs">
        <span className="font-bold">Score SEO :</span>
        <div className="flex-1 h-2 rounded-full bg-[hsl(var(--muted))] overflow-hidden">
          <div className="h-full bg-gradient-to-r from-[color:var(--brand-red)] via-amber-400 to-emerald-500" style={{width: `${score}%`}}/>
        </div>
        <span className="font-mono font-bold">{score}</span>
      </div>
    </div>
  );
}

function computeScore(t = "", d = "") {
  let s = 0;
  const tl = t.length, dl = d.length;
  if (tl >= 40 && tl <= 65) s += 40; else if (tl > 0) s += 15;
  if (dl >= 120 && dl <= 160) s += 40; else if (dl > 0) s += 15;
  if (t && d) s += 20;
  return Math.min(100, s);
}
